var viewer_caption_default = {
  "fontElementMap": "Sd0Ux",
  "imageCaption": "iUfbB"
};
export {
  viewer_caption_default as default
};
//# sourceMappingURL=viewer-caption-scss.js.map
